export const coldQuotes = [
  {
    text: 'You already have a freezer at home, why go out and do freezer every where else?',
  },
  {
    text: 'Your bed never gave you frost bite',
  },
  {
    text: 'Why deal with the cold, when House Hunters International is ALWAYS on?',
  },
  {
    text: 'I would rather quit my job, go off the grid, and drink my bubly from dirty mason jars,  instead of dealing with this cold',
  },
  {
    text: "This winter B.S happens every year. It's time to take a stand... While sitting on the couch... For freedom!",
  },
  {
    text: 'If you go outside in this cold,  your risk of having to do what those soccer players did in that movie, raises exponentially',
  },
  {
    text: "Do you even know what's on HGTV right now?",
  },
  {
    text: "There has to be some sort of leftist reason not to go out in this cold. Give me time. I'll find it",
  },
  {
    text: 'Do you have fur? No? I rest my case',
  },
  {
    text: "You wouldn't have to be going to work in this cold. if you only had taken the time to figure out how to monetize your toe nail clippings",
  },
  {
    text: "It's freezing cold. Now's a great time to stay home and figure out how to blame this on late stage capitalism"
  },
];

export const hotQuotes = [
  {
    text: 'Your bed never gave you a sunburn',
  },
  {
    text: "Sure it's 'nice out'  but only sheeple like 'nice out'. Are you a sheeple?",
  },
  {
    text: 'Dude you have an oven,  why go out where oven is EVERYWHERE?',
  },
  {
    text: "Oh you're going to the beach? Ok but first let me tell you about this documentary I watched, called Jaws",
  },
  {
    text: 'Why on gods green earth would you want to sweat?',
  },
  {
    text: "There's two kinds of people in life. Those that like warm weather activities, and people who aren't psychopaths.",
  },
  {
    text: "Do you even know what's on HGTV right now?",
  },
  {
    text: "If you step foot outside that door, I'm calling your Mom and telling her you don't eat vegetables.",
  },
  {
    text: "Let's agree to disagree, and agree I'm right about it being too hot for you to go outside",
  },
  {
    text: "You wouldn't have to go out in this heat, if you just had taken the time to figure out how to monetize your toe nail clippings",
  },
  {
    text: "Most of these forest fires are caused my arson, and when I say arson I mean the sun. Don't let the sun arson you.",
  },
];

export const sunnyQuotes = [
  {
    text: "It's really sunny out. Studies show that the strongest SPF is your TV room",
  },
  {
    text: "Look at that sun.Trust me, you don't want any piece of that",
  },
  {
    text: 'People see the Sun and they want to go outside and enjoy it. People are also stupid',
  },
  {
    text: 'Nobody talks about the positive sides of lacking vitamin D',
  },
  {
    text: "You know you can still wear your aviators at home? It's not just for shirtless beach volleyball anymore",
  },
  {
    text: "The sun is basically an unpaid landlord charging rent on your skin. Stay inside.",
},
{
  text: "UV index is a capitalist construct. Don’t let the light exploit you.", 
},
];

export const rainQuotes = [
  {
    text: 'The problem is everyone romanticizes puddles. The reality is sometimes they can hide real dangers like, broken glass...or al-Qaeda ',
  },
  {
    text: "If you need to be out in the rain so badly, just take a bath in your toilet. It's basically the same thing",
  },
  {
    text: "Look it's raining, isn't time to get reacquainted with HOUSE HUNTERS INTERNATIONAL?",
  },
  {
    text: "Fine, I'll just come out and say it. If you go out in this rain, you'll miss Drake. Because I invited him to your home. I was saving this for your birthday, but you forced my hand",
  },
  {
    text: "Go outside, but how do you know someone didn't pee in your rain boots?",
  },
  {
    text: "The rain is unionizing against your umbrella. Don’t cross the picket line."
  },
];

export const snowQuotes = [
  {
    text: 'I heard the snow is up to your knees out there. On wrong step, and that could be your NBA career!',
  },
  {
    text: "It's snowing. You know if you step outside, there's a chance an old lady will ask you to shovel her driveway.",
  },
  {
    text: "Wasn't it the ice age that killed the Dinosaurs? If you want to take that risk, be my guest and go outside.",
  },
  {
    text: 'You know what I love about a snow day like today? My duvet',
  },
  {
    text: "I don't want to bring up Godwins law, but you know what they call people who like going out in the snow, right?",
  },
  {
    text: "White supremacy has taken over the forecast, quick get inside and call Robin DiAngelo so she can explain how its your co-workers fault",
  },
{
  text: "Capitalism calls this ‘bad weather.’ We call it ‘free white noise machine.’ Stay in bed."

},
];


export const smogQuotes = [
  {
    text: "Yes you can't breathe, and sure your eyes are burning, but remember the main thing is you can stay inside and complain about pronouns on Twitter"
  },
  {
    text: "Air Quality Index: dystopian vape flavor — ‘charcoal lung.’ Stay inside.",
  },
  {
    text: "Asthema is conspircy theory created by big ventilator. Stay home. Don't let them win.", 
  },
  {
    text: " That sepia tone outside... Is outside and not an Instagram filter. Stay inside.",
  },
];

